export default "__VITE_ASSET__BXQ_PETJ__"